import { useQuery } from "@apollo/client";
import { intl } from "LocaleWrapper";
import { HistoryEntity } from "__generated__/enums";
import { ChangeRevisionsDocument } from "__generated__/components/entityHistory/graphql/entityHistory.queries.generated";
import RevisionChanges from "components/entityHistory/components/RevisionChanges";
import EntityHistoryRevisions from "components/entityHistory/components/EntityHistoryRevisions";

const EntityChangeHistory = ({ entity, entityId }: {
	entity: HistoryEntity;
	entityId: number;
}) => {

	const { data, loading, error } = useQuery(ChangeRevisionsDocument, {
		variables: { entity, entityId },
	});

	return (
		<EntityHistoryRevisions
			revisions={data?.changeRevisions ?? []}
			loading={loading}
			error={error}
			renderEmptyRemarkTitle={(revision) => {
				if (revision.changes.length === 1) {
					return intl.formatMessage({ id: "HISTORY_CHANGE_SINGLE" });
				} else {
					return intl.formatMessage({ id: "HISTORY_CHANGE_MULTIPLE" }, { numberOfChanges: revision.changes.length });
				}
			}}
			renderRevision={(revision) => (
				<RevisionChanges changes={revision.changes} />
			)}
		/>
	);
};

export default EntityChangeHistory;
